import fetch from '../../api/fetch'

/**
 *  Action to view a single Quote details
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {string} URL [/api/v1/quotes/:quoteId/view]
 *  @method GET
 */
export function getQuoteSingle(quoteId: number) {

    return {
        type: 'GET_QUOTE_SINGLE',
        payload: fetch(
            `/quotes/${quoteId}/view`
        ),
    }
}

/**
 *  Action to issue quote variations for view quote
 *
 *  @param  {number} quoteId [Quote ID]
 *  @param  {number} quoteVariationId [Quote Variation ID]
 *  @param  {string} URL [/quotes/step05/:quoteId/quoteVariations/:quoteVariationId]
 *  @method POST
 */
export function issueViewQuoteVariation(quoteId: number, quoteVariationId: number) {

    return {
        type: 'ISSUE_VIEW_QUOTE_VAR',
        payload: fetch(`/quotes/step05/${quoteId}/quoteVariations/${quoteVariationId}`, { method: 'POST' }),
        quoteId: quoteId,
    }
}

/**
 *  Action to receive the already issue quote
 *
 *  @method POST
 */
export function handleReissueQuote(quoteId: number, quoteVariationId: number) {

    return {
        type: 'DOWNLOAD_VIEW_QUOTE',
        payload: fetch(
            `/quotes/step05/${quoteId}/quoteVariations/${quoteVariationId}/reissued`, { method: 'POST' }
        ),
        quoteId: quoteId,
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/quote/view.ts